import { useTranslation } from 'react-i18next';
import axios from '../../../utils/axios';
import { useState } from 'react';
import { MIconButton } from '../../../components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack';
import { Building } from '../../../@types/model/user';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import '../../../assets/css/deviceGroupsBuildingsDevices.scss';
import BasicModal from 'components/BasicModal';

import BuildingForm from 'components/building/BuildingForm';
import { v4 as uuidv4 } from 'uuid';
import { buildingState } from 'recoil/buildingState';

interface BuildingNewModalProps {
  deviceTag: string;
  newBuildingModal: boolean;
  setNewBuildingModal: (newBuildingModal: boolean) => void;
}

const buildingInit = {
  guid: uuidv4(),
  attributes: {
    name: '',
    type: 'asset',
    device_count: 0,
    shared: false,
    is_ref_of: '',
    delivery_configurations: [],
    parent: ''
  }
};

const BuildingNewModal = (props: BuildingNewModalProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [building, setBuilding] = useState<Building>({
    ...buildingInit,
    attributes: {
      ...buildingInit.attributes,
      parent: props.deviceTag
    }
  } as Building);

  const buildings: Building[] = useRecoilValue(buildingState);
  const setBuildings = useSetRecoilState(buildingState);

  const saveBuilding = (building: Building) => {
    setLoading(true);
    axios
      .post('/api/v2/device-tag', {
        ...building,
        delivery_configurations: [],
        attributes: { ...building.attributes, parent: props.deviceTag }
      })
      .then(() => {
        setLoading(false);
        enqueueSnackbar(t('building_created'), {
          variant: 'success',
          action: (key) => (
            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
              <Icon icon={closeFill} />
            </MIconButton>
          )
        });
        props.setNewBuildingModal(false);
        setBuilding({ ...buildingInit, guid: uuidv4() });
        setBuildings([...buildings, building]);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <BasicModal
      open={props.newBuildingModal}
      handleClose={() => {
        setLoading(false);
        props.setNewBuildingModal(false);
        setBuilding({ ...buildingInit, guid: uuidv4() });
      }}
    >
      <h2 style={{ marginBottom: '10px' }}>{t('create_building')}</h2>

      <BuildingForm
        building={building}
        loading={loading}
        edit={false}
        submitHandler={saveBuilding}
      />
    </BasicModal>
  );
};

export default BuildingNewModal;
